import { create } from 'zustand';
import { apiService } from '../services/api';

const useInventoryStore = create((set, get) => ({
	items: [],
	isLoading: false,
	error: null,
	lastUpdated: null,

	// Получение всех предметов
	fetchItems: async (force = false) => {
		const now = Date.now();
		const lastUpdated = get().lastUpdated;
		console.log('fetchItems вызван:', {
			force,
			now,
			lastUpdated,
			timeDiff: lastUpdated ? now - lastUpdated : 'нет данных',
			hasItems: get().items.length > 0
		});
		// Если не force и прошло меньше 15 секунд — не обновляем
		if (!force && lastUpdated && now - lastUpdated < 15000) {
			console.log('fetchItems: пропускаем запрос, данные актуальны');
			return get().items;
		}

		console.log('fetchItems: делаем запрос');
		set({ isLoading: true, error: null });
		try {
			const response = await apiService.getUserItems();
			const items = Array.isArray(response) ? response : response.data || [];
			set({ items, isLoading: false, lastUpdated: Date.now() });
			return items;
		} catch (error) {
			set({ error: error.message, isLoading: false });
			throw error;
		}
	},

	// Добавление нового предмета
	addItem: (item) => {
		set((state) => {
			// Проверяем, есть ли уже такой предмет в инвентаре
			const itemExists = state.items.some(existingItem => existingItem.id === item.id);
			if (itemExists) {
				return state; // Если предмет уже есть, не добавляем его снова
			}
			return {
				items: [...state.items, item]
			};
		});
	},

	// Обновление статуса предмета
	updateItemStatus: (itemId, newStatus) => {
		set((state) => ({
			items: state.items.map((item) =>
				item.id === itemId ? { ...item, status: newStatus } : item
			)
		}));
	},

	// Удаление предмета
	removeItem: (itemId) => {
		set((state) => ({
			items: state.items.filter((item) => item.id !== itemId)
		}));
	},

	// Очистка всех предметов
	clearItems: () => {
		set({ items: [] });
	},

	// Обновление нескольких предметов
	updateItems: (newItems) => {
		set({ items: newItems });
	}
}));

export default useInventoryStore;
